import { render, staticRenderFns } from "./FlexTable.vue?vue&type=template&id=b4ff7d04&scoped=true&"
import script from "./FlexTable.vue?vue&type=script&lang=js&"
export * from "./FlexTable.vue?vue&type=script&lang=js&"
import style0 from "./FlexTable.vue?vue&type=style&index=0&id=b4ff7d04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ff7d04",
  null
  
)

export default component.exports